<span class="app-chip">
  <span class="app-chip__text">
    <ng-content></ng-content>
  </span>
  <button type="button" class="app-chip__btn" *ngIf="removable" (click)="removeItem()"
          [attr.aria-label]="'Usuń '+ariaText">
     <mat-icon [svgIcon]="removeIcon | async"></mat-icon>
  </button>
</span>
